export default function Board() {
  return (
    <div className="section-heading">
      <h2 h2 > Board of Directors</h2>
      <div className="board-group">
        <div className="board-seat">
          <span className="board-member">Christian Cummings</span>
          <span className="board-title">Executive Director</span>
        </div>
        <div className="board-seat">
          <span className="board-member">Max Martin</span>
          <span className="board-title">Treasurer</span>
        </div>
        <div className="board-seat">
          <span className="board-member">Carlos Morera</span>
          <span className="board-title">Secretary</span>
        </div>
        <div className="board-seat">
          <span className="board-member">Marshall Birnbaum</span>
          <span className="board-title">Director of Operations</span>
        </div>

        <div className="board-seat">
          <span className="board-member">Joseph Valle</span>
          <span className="board-title">Programming Director</span>
        </div>
        <div className="board-seat">
          <span className="board-member">Sandeep Rangi</span>
          <span className="board-title">Financial Director</span>
        </div>

        {/* <div className="board-seat">
          <span className="board-member">Sarah Agudo</span>
          <span className="board-title">Director</span>
        </div> */}
      </div>

      <h2>Advisory Board</h2>
      <div className="board-group">
        <div className="board-seat">
          <h3>Evan Meyer</h3>
          <span className="board-title">Botanist</span>
        </div>
        <div className="board-seat">
          <h3>Li Murphy</h3>
          <span className="board-title">Entemologist</span>
        </div>
        <div className="board-seat">
          <h3>John Mayer</h3>
          <span className="board-title">Musician</span>
        </div>
        <div className="board-seat">
          <h3>Emma Reeves</h3>
          <span className="board-title">Creative Strategist</span>
        </div>
        <div className="board-seat">
          <h3>Susan Morris</h3>
          <span className="board-title">Producer</span>
        </div>
        <div className="board-seat">
          <h3>Angus Wall</h3>
          <span className="board-title">Film Producer & Editor</span>
        </div>
        <div className="board-seat">
          <h3>Sasha Markova</h3>
          <span className="board-title">Writer & Creative Director</span>
        </div>
        <div className="board-seat">
          <h3>Andy Rifkin</h3>
          <span className="board-title">Real Estate Capital Partner</span>
        </div>
        <div className="board-seat">
          <h3>Gracia Echeverria</h3>
          <span className="board-title">Designer</span>
        </div>
        
      </div>
      <h2>Staff</h2>
      <div className="board-group">
        {/* <div className="board-seat">
          <h3>Christian Cummings</h3>
          <span className="board-title">Executive Director</span>
        </div>
        <div className="board-seat">
          <h3>Sandeep Rangi</h3>
          <span className="board-title">Accounting and Finance</span>
        </div> */}

        <div className="board-seat">
          <h3>William Ramirez</h3>
          <span className="board-title">Greenhouse Manager</span>
        </div>
        <div className="board-seat">
          <h3>Sarah Agudo</h3>
          <span className="board-title">Legal</span>
        </div>
        <div className="board-seat">
          <h3>Isabel Mesko</h3>
          <span className="board-title">Creative Strategist</span>
        </div>
      </div>
    </div>
  )
}